<template>
    <div class="w-full">
        <!-- 手机样式 -->
        <div class="phone_header">
            <div class="left-btn cursor-pointer" @click="showSiderbarBox">
                <img class="w-[25px] h-[19px]" src="@/assets/icon_phone_slide.png" alt="">
            </div>
            <div class="center-tabbar flex-1">
                <div class="flex flex-row justify-center">
                    <div class="nav-tab" :class="{ 'active-tab': !tabIndex }" @click="toggleTab(0)">
                        对话
                    </div>
                    <div class="nav-tab" :class="{ 'active-tab': tabIndex }" @click="toggleTab(1)">
                        推荐
                    </div>
                </div>
            </div>
            <div slot="reference" class="w-[30px] h-[30px] rounded-full" @click="gotoMyPage">
                <img class="w-full h-full rounded-full" :src="userInfo && userInfo.avatar ? userInfo.avatar: headImg"/>
            </div>
        </div>
        <!-- pc样式 -->
        <!-- <div class="header"> 
            <div class="free_user" buyVip
              :class="userInfo && userInfo.is_vip ? 'vip_user' : ''"
              @click="buyVip"
              @mouseover="hideInfoHandeler">
                <span class="vip_info" v-if="userInfo && userInfo.is_vip">您的VIP有效期至{{userInfo.expire_date}}</span>
            </div>

            <div class="box1">
                <img class="avatar" :src="userInfo && userInfo.avatar ? userInfo.avatar : headImg" @mouseover="showInfo = true" @mouseleave="hideInfo">
                <div class="login_box" v-show="showInfo" @mouseover="showInfoHandeler" @mouseleave="hideInfo">
                    <p>ID：{{ userInfo ? userInfo.medlive_id : 0 }}</p>
                    <p class="text-[#4C5BDF]">{{userInfo ? userInfo.name : ''}}</p>
                    <p @click="goOrder">我的订单</p>
                    <div class="text-center" @click="loginOut">退出登录</div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
export default {
    name: "NavBar",
    data() {
        return {
            is_vip: false,
            headImg: require("@/assets/avatar.png"),
            showInfo: false,
            infoTimer:null
        };
    },
    props: {
        tabIndex: {
            default: 0
        }
    },
    computed: {
        ...mapState(["userInfo"]),

    },
    mounted() {
        console.log(this.userInfo)
    },
    methods: {
		...mapMutations(['setUserInfo']),
        showSiderbarBox() {
            this.$emit("openSiderbar");
        },
        toggleTab(index) {
            if (index == this.tabIndex) return
            this.$emit("toggle", index);
        },
		goLogin() {
            window.location.href = `${process.env.VUE_APP_BASE_URL}/cas/auth?redirectUri=${encodeURIComponent(
                window.location.href
            )}`;
        },
		loginOut() {
            window.location.href = `${process.env.VUE_APP_BASE_URL}/cas/logout?token=${window.localStorage.getItem('token')}`
            window.localStorage.removeItem("token")
			this.setUserInfo(null)
		},
        gotoMyPage(){
           this.$router.push('/my')
        },
        hideInfo(){
            this.infoTimer = setTimeout(()=>{
                this.showInfo = false
            },2000)
        },
        buyVip() {
            // this.$emit("openVip")
            //console.log(this.$route);
            if(this.$route.path != '/buyvip'){
                this.$router.push('/buyvip')
            }  
        },
        goOrder() {
            if (this.$route.path != '/myorder') {
                this.$router.push('/myorder')
            }
        },
        hideInfoHandeler() {
            clearTimeout(this.infoTimer)
            this.showInfo = false
        },
        showInfoHandeler(){
            clearTimeout(this.infoTimer)
            this.showInfo = true
        }
    },
};
</script>

<style lang="scss" scoped>
// pc样式
.header {
    @apply h-14 max-sm:hidden flex flex-row items-center justify-end px-8 border-b border-[#C2C4CB];
    .free_user{
        background: url(@/assets/icon_free_pc.png) no-repeat;
        background-size: 100% auto;
        @apply w-[78px] h-[78px] mr-1 cursor-pointer relative;
        .vip_info{
            background: url(@/assets/youxiaoqi.png) no-repeat;
            background-size: 100% auto;
            @apply w-[194px] h-[30px] pt-2 absolute top-[70px] left-[50%] ml-[-100px] hidden text-xs text-center text-[#7B5D41] z-20;
        }
        &:hover{
            .vip_info{
                @apply block;
            }
            .login_box{
                @apply hidden;
            }
        }
    }
    .vip_user{
        background: url(@/assets/icon_vip_pc.png) no-repeat;
        background-size: 100% auto;
    }
    .box1 {
        @apply relative w-[46px] h-[46px] rounded-full cursor-pointer;
        .avatar {
            @apply w-full h-full rounded-full;
        }
    }
    .login_box{
        @apply w-[158px] bg-white py-[20px] absolute top-[60px] right-0 px-[20px] rounded-[10px] z-10 text-sm;
        box-shadow: 0px 4px 20px #D6D9E4;
        &::before {
            @apply absolute right-[15px] top-[-8px];
            content: '';
            border-bottom: 8px solid #fff;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
        }
        &>p {
            @apply leading-[25px] text-center mb-[15px];
        }
        &>div {
            @apply pt-[15px] leading-[25px] text-[#000000] border-t border-[#C2C4CB];
        }
    }
}

.vip {
    flex-shrink: 0;
    box-shadow: (0px 4px 12px rgba(219, 223, 233, 0.8));
    @apply w-[46px] h-[46px] bg-white rounded-full;
}
.vip img {
    @apply w-[23px] h-[29px];
}


// 手机样式
.phone_header {
    @apply sm:hidden px-4 h-[59px] w-full flex flex-row justify-between items-center text-base;
}
.nav-tab {
    @apply mx-[33px];
}
.active-tab {
    @apply relative text-[#4C5BDF] font-semibold;
}
.active-tab::before {
    content: '';
    @apply h-0.5 absolute right-0 bottom-0 left-0 bg-[#4C5BDF] rounded-sm;
}
</style>